export const iconFontAwesomeEducationSchoolCircleExclamation = (
	<i className="fa-solid fa-school-circle-exclamation"></i>
);
